import React, { useEffect, useState, useMemo } from "react";
import { motion } from 'framer-motion'
import API from "../../Common/API";
import InlineTextField from "../../Components/InLineTextField";
import DatatableLoader from "../../Components/Loaders/DataTableLoader"
import { datatableTheme } from "../../Common/dataTableTheme"
import DataTable, { createTheme } from "react-data-table-component"
import { BsImageAlt } from "react-icons/bs";
import { useHistory } from "react-router-dom";
import { FaPen, FaPlus, FaTrash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "../../Components/Dialog";
import FieldInput from "../../Components/FieldInput";
import * as Yup from 'yup'
import { useFormik } from "formik";
import Button from "../../Components/Button";
import { setAlert } from "../../Store/Theme/actions";

createTheme('defaultLight', datatableTheme.default)
createTheme('defaultDark', datatableTheme.dark)

const initialPickupForm = {
    pickupPointName: '',
    pickupAddress: {
        pinCode: '',
        addressLine1: '',
        addressLine2: '',
        state: '',
        city: '',
        landMark: '',
        district: ''
    }
}

const AddPickupPoints = () => {

    const userDetails = useSelector((state) => state.auth.userDetails)
    const [loading, setLoading] = useState(true)
    const [filter, setFilter] = useState('')
    const [pickupList, setPickupList] = useState([])
    const history = useHistory()
    const [openModal, setOpenModal] = useState(false)
    const [addressEdit, setAddressEdit] = useState(false)
    const dispatch = useDispatch()
    const [submitDisabled, setSubmitDisabled] = useState(false)
    const [count, setCount] = useState(0)
    const [initialData, setInitialData] = useState(initialPickupForm)
    const [editModal, setEditModal] = useState(false)

    useEffect(() => {
        setLoading(true)
        API.get('/accounts/pickuPoints')
            .then((productRes) => {
                setPickupList(productRes.data.data)
            })
            .finally(() => {
                setLoading(false)
            })
    }, [count])

    const columns = useMemo(() => [
        { name: 'S.No', selector: (row, i) => i + 1, initialActive: true, sortable: true, width: '100px' },
        { name: 'Incharge Name', selector: row => row.inchargeName, initialActive: true, sortable: true },
        { name: 'Incharge Mobile', selector: row => row.inchargeMobile, initialActive: true, sortable: true },
        { name: 'Pikcup Point Name', selector: row => row.pickupPointName, initialActive: true, sortable: true },
        { name: 'Address Line1', selector: row => row.pickupAddress.addressLine1, sortable: true },
        { name: 'Address Line2', selector: row => row.pickupAddress.addressLine2 || '-', sortable: true },
        { name: 'City', selector: row => row.pickupAddress.city, sortable: true },
        { name: 'District', selector: row => row.pickupAddress.district, sortable: true },
        { name: 'Landmark', selector: row => row.pickupAddress.landMark, sortable: true },
        { name: 'State', selector: row => row.pickupAddress.state, sortable: true },
        { name: 'Pincode', selector: row => row.pickupAddress.pinCode, sortable: true },
        { name: 'Status', selector: row => row.activeStat === 'A' ? 'Activated' : 'Deactivated', sortable: true },
        {
            name: 'Action', selector: row => <motion.div className="px-1 py-1 w-full flex flex-row justify-between cursor-pointer">
                {/* <FaEye className="cursor-pointer" onClick={() => viewOrder(row)} />&nbsp;&nbsp;&nbsp;&nbsp; */}
                <FaPen className="cursor-pointer text-[blue]" onClick={() => editAddress(row)} />&nbsp;&nbsp;&nbsp;&nbsp;
                <FaTrash className="cursor-pointer text-[red]" />&nbsp;&nbsp;&nbsp;&nbsp;
            </motion.div>
        }
    ], [])

    const filteredcasedetails = useMemo(() => {
        const filterSplit = filter.toLowerCase().split(' ')
        return pickupList.filter(c =>
            filterSplit.every(i =>
                Object.keys(c).some(j => c[j]?.toString().toLowerCase().includes(i))
            )
        )
    }, [pickupList, filter])

    const SubHeader = useMemo(() => (
        <div className="flex flex-row items-center">
            <InlineTextField label={"Search"} value={filter} setValue={setFilter} />
            <motion.div className="h-9 mx-2 w-9 rounded-full bg-white flex flex-col items-center cursor-pointer justify-center" onClick={() => setOpenModal(true)}><FaPlus /></motion.div>
        </div>
    ), [filter])// eslint-disable-line


    const pickupPointSchema = Yup.object().shape({
        inchargeName: Yup.string().required("Incharge Name is required"),
        inchargeMobile: Yup.string().required("Mobile Number is required"),
        pickupPointName: Yup.string().required("Pickup point name is required"),
        pickupAddress: Yup.object().shape({
            pinCode: Yup.string().required("Pincode is required"),
            addressLine1: Yup.string().required("Address line 1 is required"),
            addressLine2: Yup.string().nullable(),
            state: Yup.string().required("State is required"),
            city: Yup.string().required("City is required"),
            district: Yup.string().required("District is required")
        })
    })


    const pickupForm = useFormik({
        initialValues: initialData,
        validateOnMount: true,
        validationSchema: pickupPointSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            setSubmitDisabled(true)
            API.post('/accounts/savePickupPoint', values).then((pickupRes) => {
                if (pickupRes.status === 200) {
                    dispatch(setAlert({ title: 'Success', subtitle: 'Pickup points added', active: true, type: 'success' }))
                    pickupForm.resetForm()
                    setAddressEdit(false)
                    setOpenModal(false)
                    setSubmitDisabled(false)
                    setCount(count + 1)
                }
            })
        }
    })

    const getLocation = (value) => {
        if (value.length === 6) {
            API.get(`/common/getLocationByPincode?pinCode=${value}`).then((pinRes) => {
                if (pinRes.status === 200) {
                    const location = pinRes.data.data;
                    pickupForm.setValues({
                        ...pickupForm.values, pickupAddress: {
                            city: location?.city || '',
                            district: location?.district || '',
                            pinCode: location?.pinCode || '',
                            state: location?.state || '',
                        }
                    })
                    setAddressEdit(true);
                }
            });
        } else if (value.length === 0) {
            pickupForm.setValues({
                ...pickupForm.values, pickupAddress: {
                    city: '',
                    district: '',
                    pinCode: '',
                    state: '',
                }
            })
            setAddressEdit(false);
        }
    };

    const editAddress = (value) => {
        setEditModal(true)
        setInitialData(value)
        console.log(value)
    }

    const editPickupForm = () => {
        setSubmitDisabled(true)
        API.post('/accounts/editPickupPoint', pickupForm.values).then((pickupRes) => {
            if (pickupRes.status === 200) {
                dispatch(setAlert({ title: 'Success', subtitle: 'Pickup points edited', active: true, type: 'success' }))
                pickupForm.resetForm()
                setEditModal(false)
                setInitialData(initialPickupForm)
                setSubmitDisabled(false)
                setCount(count + 1)
            }
        }).catch((err) => {
            dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong', active: true, type: 'error' }))
            setSubmitDisabled(false)
        })
    }

    return (
        <motion.div>
            {loading ? (
                <DatatableLoader />
            ) : (
                <motion.div className="h-full w-full bg-opacity-10 drop-shadow-lg">
                    <DataTable
                        title="Pickup Points List"
                        theme="defaultLight"
                        columns={columns}
                        data={filteredcasedetails}
                        pagination
                        highlightOnHover
                        selectableRowsHighlight
                        persistTableHead
                        subHeader
                        subHeaderComponent={SubHeader}
                        noDataComponent={'There are no records to display'}
                    />
                </motion.div>
            )}
            <Dialog title={'Add Pickup Points'} injectClass="w-[550px]" showDialog={openModal} onClose={() => setOpenModal(false)}>
                <motion.div className="relative flex flex-col w-full">
                    <motion.div className="grid grid-cols-1 w-full">
                        <FieldInput label={'Incharge Name'} fieldProps={pickupForm.getFieldProps('inchargeName')} fieldHelper={pickupForm.getFieldHelpers('inchargeName')} fieldMeta={pickupForm.getFieldMeta('inchargeName')} edit={true} dataLoaded={true} />
                        <FieldInput label={'Incharge Mobile Number'} fieldProps={pickupForm.getFieldProps('inchargeMobile')} fieldHelper={pickupForm.getFieldHelpers('inchargeMobile')} fieldMeta={pickupForm.getFieldMeta('inchargeMobile')} edit={true} dataLoaded={true} />
                        <FieldInput label={'Pickup Point Name'} fieldProps={pickupForm.getFieldProps('pickupPointName')} fieldHelper={pickupForm.getFieldHelpers('pickupPointName')} fieldMeta={pickupForm.getFieldMeta('pickupPointName')} edit={true} dataLoaded={true} />
                        <FieldInput label={'PinCode'} fieldProps={pickupForm.getFieldProps('pickupAddress.pinCode')} fieldHelper={pickupForm.getFieldHelpers('pickupAddress.pinCode')} fieldMeta={pickupForm.getFieldMeta('pickupAddress.pinCode')} edit={true} dataLoaded={true} onChange={(e) => getLocation(e)} />
                        <FieldInput label={'Address Line1'} fieldProps={pickupForm.getFieldProps('pickupAddress.addressLine1')} fieldHelper={pickupForm.getFieldHelpers('pickupAddress.addressLine1')} fieldMeta={pickupForm.getFieldMeta('pickupAddress.addressLine1')} edit={addressEdit} dataLoaded={true} />
                        <FieldInput label={'Address Line2'} fieldProps={pickupForm.getFieldProps('pickupAddress.addressLine2')} fieldHelper={pickupForm.getFieldHelpers('pickupAddress.addressLine2')} fieldMeta={pickupForm.getFieldMeta('pickupAddress.addressLine2')} edit={addressEdit} dataLoaded={true} />
                        <FieldInput label={'City'} fieldProps={pickupForm.getFieldProps('pickupAddress.city')} fieldHelper={pickupForm.getFieldHelpers('pickupAddress.city')} fieldMeta={pickupForm.getFieldMeta('pickupAddress.city')} edit={addressEdit} dataLoaded={true} />
                        <FieldInput label={'District'} fieldProps={pickupForm.getFieldProps('pickupAddress.district')} fieldHelper={pickupForm.getFieldHelpers('pickupAddress.district')} fieldMeta={pickupForm.getFieldMeta('pickupAddress.district')} edit={addressEdit} dataLoaded={true} />
                        <FieldInput label={'Landmark'} fieldProps={pickupForm.getFieldProps('pickupAddress.landMark')} fieldHelper={pickupForm.getFieldHelpers('pickupAddress.landMark')} fieldMeta={pickupForm.getFieldMeta('pickupAddress.landMark')} edit={addressEdit} dataLoaded={true} />
                        <FieldInput label={'State'} fieldProps={pickupForm.getFieldProps('pickupAddress.state')} fieldHelper={pickupForm.getFieldHelpers('pickupAddress.state')} fieldMeta={pickupForm.getFieldMeta('pickupAddress.state')} edit={addressEdit} dataLoaded={true} />
                    </motion.div>
                    <motion.div className="w-full flex flex-row relative justify-between">
                        <Button type={'secondary'} injectClass={'rounded bg-red-900 text-white'}>Cancel</Button>
                        <Button injectClass={`bg-[green] rounded text-white cursor-pointer`} disabled={submitDisabled} onClick={() => !submitDisabled && pickupForm.submitForm()}>Save</Button>
                    </motion.div>
                </motion.div>
            </Dialog>

            <Dialog title={'Edit Pickup Points'} injectClass="w-[550px]" showDialog={editModal} onClose={() => setEditModal(false)}>
                <motion.div className="relative flex flex-col w-full">
                    <motion.div className="grid grid-cols-1 w-full">
                        <FieldInput label={'Incharge Name'} fieldProps={pickupForm.getFieldProps('inchargeName')} fieldHelper={pickupForm.getFieldHelpers('inchargeName')} fieldMeta={pickupForm.getFieldMeta('inchargeName')} edit={true} dataLoaded={true} />
                        <FieldInput type="phone" label={'Incharge Mobile Number'} fieldProps={pickupForm.getFieldProps('inchargeMobile')} fieldHelper={pickupForm.getFieldHelpers('inchargeMobile')} fieldMeta={pickupForm.getFieldMeta('inchargeMobile')} edit={true} dataLoaded={true} />
                        <FieldInput label={'Pickup Point Name'} fieldProps={pickupForm.getFieldProps('pickupPointName')} fieldHelper={pickupForm.getFieldHelpers('pickupPointName')} fieldMeta={pickupForm.getFieldMeta('pickupPointName')} edit={true} dataLoaded={true} />
                        <FieldInput label={'PinCode'} fieldProps={pickupForm.getFieldProps('pickupAddress.pinCode')} fieldHelper={pickupForm.getFieldHelpers('pickupAddress.pinCode')} fieldMeta={pickupForm.getFieldMeta('pickupAddress.pinCode')} edit={true} dataLoaded={true} onChange={(e) => getLocation(e)} />
                        <FieldInput label={'Address Line1'} fieldProps={pickupForm.getFieldProps('pickupAddress.addressLine1')} fieldHelper={pickupForm.getFieldHelpers('pickupAddress.addressLine1')} fieldMeta={pickupForm.getFieldMeta('pickupAddress.addressLine1')} edit={true} dataLoaded={true} />
                        <FieldInput label={'Address Line2'} fieldProps={pickupForm.getFieldProps('pickupAddress.addressLine2')} fieldHelper={pickupForm.getFieldHelpers('pickupAddress.addressLine2')} fieldMeta={pickupForm.getFieldMeta('pickupAddress.addressLine2')} edit={true} dataLoaded={true} />
                        <FieldInput label={'City'} fieldProps={pickupForm.getFieldProps('pickupAddress.city')} fieldHelper={pickupForm.getFieldHelpers('pickupAddress.city')} fieldMeta={pickupForm.getFieldMeta('pickupAddress.city')} edit={true} dataLoaded={true} />
                        <FieldInput label={'District'} fieldProps={pickupForm.getFieldProps('pickupAddress.district')} fieldHelper={pickupForm.getFieldHelpers('pickupAddress.district')} fieldMeta={pickupForm.getFieldMeta('pickupAddress.district')} edit={true} dataLoaded={true} />
                        <FieldInput label={'Landmark'} fieldProps={pickupForm.getFieldProps('pickupAddress.landMark')} fieldHelper={pickupForm.getFieldHelpers('pickupAddress.landMark')} fieldMeta={pickupForm.getFieldMeta('pickupAddress.landMark')} edit={true} dataLoaded={true} />
                        <FieldInput label={'State'} fieldProps={pickupForm.getFieldProps('pickupAddress.state')} fieldHelper={pickupForm.getFieldHelpers('pickupAddress.state')} fieldMeta={pickupForm.getFieldMeta('pickupAddress.state')} edit={true} dataLoaded={true} />
                    </motion.div>
                    <motion.div className="w-full flex flex-row relative justify-between">
                        <Button type={'secondary'} injectClass={'rounded bg-red-900 text-white'} onClick={() => { setInitialData(initialPickupForm); setEditModal(false) }}>Cancel</Button>
                        <Button injectClass={`bg-[green] rounded text-white cursor-pointer`} disabled={submitDisabled} onClick={() => !submitDisabled && editPickupForm()}>Save</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
        </motion.div>
    )
}

export default AddPickupPoints